import { GenericVehicleDetails, useFetchProduct } from '@finn/ua-vehicle';
import { useEffect } from 'react';

export const useVehicleData = (
  vehicleId: string,
  initialVehicle: GenericVehicleDetails | null
) => {
  const {
    data: vehicle,
    error,
    isLoading,
  } = useFetchProduct({ vehicleId }, initialVehicle);

  if (error) {
    console.error({ message: error, category: 'SWR Vehicle Api Call - PDP' });
  }

  useEffect(() => {
    if (error && vehicle) {
      vehicle.availability = null;
    }
  }, [error, vehicle]);

  return { vehicle, error, isLoading };
};
